/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILoyaltyStoreSignUpData } from './loyalty-store-sign-up.data';
import { ILoyaltyStoreSignUpProps } from './loyalty-store-sign-up.props.autogenerated';

export interface ILoyaltyStoreSignUpViewProps extends ILoyaltyStoreSignUpProps<ILoyaltyStoreSignUpData> {}

/**
 *
 * LoyaltyStoreSignUp component
 * @extends {React.PureComponent<ILoyaltyStoreSignUpProps<ILoyaltyStoreSignUpData>>}
 */
class LoyaltyStoreSignUp extends React.PureComponent<ILoyaltyStoreSignUpProps<ILoyaltyStoreSignUpData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LoyaltyStoreSignUp;
